<template>
  <DialogBase
    :visible.sync="visible"
    title="Thông tin bổ sung"
    dialog-class="sk-dialog--lg"
    :use-panel="false"
    :show-cancel="false"
    :show-confirm="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <div class="aid-dialog" v-loading="loading">
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="formRules"
        label-position="top"
      >
        <div class="sk-panel aid-dialog__panel">
          <div class="sk-panel-head">
            <div class="sk-panel-icon"><i class="el-icon-user" /></div>
            <div>
              <p class="sk-panel-title">Thông tin điểm danh bổ sung</p>
              <p class="sk-panel-subtitle" v-if="studentName">Học sinh: {{ studentName }}</p>
              <p class="sk-panel-subtitle" v-if="dataForm.descriptionTurn">{{ dataForm.descriptionTurn }}</p>
              <p class="sk-panel-subtitle" v-else-if="month && year">Đợt {{ turn }} - Tháng {{ month }}/{{ year }}</p>
            </div>
          </div>

          <div class="aid-dialog__head">
            <div>Tiêu đề</div>
            <div>Tháng {{ month }}</div>
            <div>{{ monthBeforeLabel }}</div>
            <div>Bổ sung</div>
          </div>

          <div class="aid-dialog__row" v-for="item in metricRows" :key="item.key">
            <div class="aid-dialog__cell aid-dialog__cell--title">{{ item.label }}</div>
            <div class="aid-dialog__cell">{{ valueOrZero(dataForm[item.totalKey]) }}</div>
            <div class="aid-dialog__cell">{{ valueOrZero(dataForm[item.monthBeforeKey]) }}</div>
            <div class="aid-dialog__cell aid-dialog__cell--edit">
              <el-form-item :prop="item.valueKey" class="aid-dialog__form-item">
                <el-input-number
                  v-model="dataForm[item.valueKey]"
                  :min="0"
                  :step="1"
                  size="small"
                  controls-position="right"
                  class="sk-u-w-full"
                />
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="sk-panel aid-dialog__panel sk-u-mt-12">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--success"><i class="el-icon-document" /></div>
            <div>
              <p class="sk-panel-title">Nội dung ghi chú</p>
              <p class="sk-panel-subtitle">Ghi chú hiển thị đồng bộ cho phiếu thu</p>
            </div>
          </div>

          <el-form-item label="Ghi chú" prop="note">
            <el-input
              v-model="dataForm.note"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              placeholder="Nhập ghi chú bổ sung"
            />
          </el-form-item>
        </div>

        <div class="sk-panel aid-dialog__panel sk-u-mt-12">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--warning"><i class="el-icon-time" /></div>
            <div>
              <p class="sk-panel-title">Thời gian tính toán áp dụng</p>
              <p class="sk-panel-subtitle">Thời gian tính toán ghi nhận từ hệ thống (không thể chỉnh sửa)</p>
            </div>
          </div>

          <el-row :gutter="12">
            <el-col :span="24">
              <span class="sk-form-item-group-label" style="font-weight: 600; font-size: 13px; color: #1e293b; display: block; margin-bottom: 8px;">
                Thời gian tính trước
                <el-tooltip content="Thời gian tính trước dùng để tính theo lịch học" placement="top">
                  <i class="el-icon-question tdi-help-icon ml-1" style="cursor: pointer; color: #909399;" />
                </el-tooltip>
              </span>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Từ ngày">
                <el-date-picker
                  v-model="dataForm.preCalcStartDate"
                  type="date"
                  disabled
                  value-format="yyyy-MM-dd"
                  format="dd-MM-yyyy"
                  class="sk-u-w-full"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Đến ngày">
                <el-date-picker
                  v-model="dataForm.preCalcEndDate"
                  type="date"
                  disabled
                  value-format="yyyy-MM-dd"
                  format="dd-MM-yyyy"
                  class="sk-u-w-full"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="12" class="sk-u-mt-12">
            <el-col :span="24">
              <span class="sk-form-item-group-label" style="font-weight: 600; font-size: 13px; color: #1e293b; display: block; margin-bottom: 8px;">
                Thời gian tính sau
                <el-tooltip content="Thời gian tính sau dùng để tính dựa trên dữ liệu điểm danh thực tế" placement="top">
                  <i class="el-icon-question tdi-help-icon ml-1" style="cursor: pointer; color: #909399;" />
                </el-tooltip>
              </span>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Từ ngày">
                <el-date-picker
                  v-model="dataForm.postCalcStartDate"
                  type="date"
                  disabled
                  value-format="yyyy-MM-dd"
                  format="dd-MM-yyyy"
                  class="sk-u-w-full"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Đến ngày">
                <el-date-picker
                  v-model="dataForm.postCalcEndDate"
                  type="date"
                  disabled
                  value-format="yyyy-MM-dd"
                  format="dd-MM-yyyy"
                  class="sk-u-w-full"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="sk-panel aid-dialog__panel sk-u-mt-12">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--primary"><i class="el-icon-date" /></div>
            <div>
              <p class="sk-panel-title">Khoảng thời gian áp dụng</p>
              <p class="sk-panel-subtitle">Khoảng thời gian phiếu thu có hiệu lực (không thể chỉnh sửa)</p>
            </div>
          </div>

          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item label="Từ ngày">
                <el-date-picker
                  v-model="dataForm.startValidityPeriod"
                  type="date"
                  disabled
                  value-format="yyyy-MM-dd"
                  format="dd-MM-yyyy"
                  class="sk-u-w-full"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Đến ngày">
                <el-date-picker
                  v-model="dataForm.endValidityPeriod"
                  type="date"
                  disabled
                  value-format="yyyy-MM-dd"
                  format="dd-MM-yyyy"
                  class="sk-u-w-full"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>

    <template #footer>
      <div class="sk-dialog__footer">
        <el-button class="btn-cancel" plain @click="handleClose">Hủy</el-button>
        <el-button class="btn-save" type="primary" :loading="saving" @click="handleSave">Lưu</el-button>
      </div>
    </template>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

const createDefaultDataForm = () => ({
  arriveT2t6: 0,
  arriveT7: 0,
  arriveCn: 0,
  absentCpT2t6: 0,
  absentKpT2t6: 0,
  absentCpT7: 0,
  absentKpT7: 0,
  leaveLater: 0,
  quantityDate: 0,
  note: "",
  arriveT2t6Total: 0,
  arriveT7Total: 0,
  arriveCnTotal: 0,
  absentCpT2t6Total: 0,
  absentKpT2t6Total: 0,
  absentCpT7Total: 0,
  absentKpT7Total: 0,
  leaveLaterTotal: 0,
  quantityDateTotal: 0,
  descriptionTurn: "",
  arriveT2t6TotalMonthBefore: 0,
  arriveT7TotalMonthBefore: 0,
  arriveCnTotalMonthBefore: 0,
  absentCpT2t6TotalMonthBefore: 0,
  absentKpT2t6TotalMonthBefore: 0,
  absentCpT7TotalMonthBefore: 0,
  absentKpT7TotalMonthBefore: 0,
  leaveLaterTotalMonthBefore: 0,
  quantityDateTotalMonthBefore: 0,
  preCalcStartDate: null,
  preCalcEndDate: null,
  postCalcStartDate: null,
  postCalcEndDate: null,
  startValidityPeriod: null,
  endValidityPeriod: null,
});

export default {
  name: "AdditionalInfoDialog",
  components: { DialogBase },
  data() {
    return {
      visible: false,
      loading: false,
      saving: false,
      idx: "",
      studentName: "",
      month: null,
      year: null,
      turn: null,
      dataForm: createDefaultDataForm(),
      formRules: {
        arriveT2t6: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        arriveT7: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        arriveCn: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        absentCpT2t6: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        absentKpT2t6: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        absentCpT7: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        absentKpT7: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        leaveLater: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
        quantityDate: [{ validator: this.validateNonNegativeInteger, trigger: "change" }],
      },
    };
  },
  computed: {
    monthBeforeLabel() {
      if (!this.month || !this.year) return "Tháng trước";
      if (this.month === 1) return `Tháng 12/${this.year - 1}`;
      return `Tháng ${this.month - 1}/${this.year}`;
    },
    metricRows() {
      return [
        { key: "arriveT2t6", label: "Học T2-T6", totalKey: "arriveT2t6Total", monthBeforeKey: "arriveT2t6TotalMonthBefore", valueKey: "arriveT2t6" },
        { key: "arriveT7", label: "Học T7", totalKey: "arriveT7Total", monthBeforeKey: "arriveT7TotalMonthBefore", valueKey: "arriveT7" },
        { key: "arriveCn", label: "Học CN", totalKey: "arriveCnTotal", monthBeforeKey: "arriveCnTotalMonthBefore", valueKey: "arriveCn" },
        { key: "absentCpT2t6", label: "Nghỉ có phép (T2-T6)", totalKey: "absentCpT2t6Total", monthBeforeKey: "absentCpT2t6TotalMonthBefore", valueKey: "absentCpT2t6" },
        { key: "absentKpT2t6", label: "Nghỉ không phép (T2-T6)", totalKey: "absentKpT2t6Total", monthBeforeKey: "absentKpT2t6TotalMonthBefore", valueKey: "absentKpT2t6" },
        { key: "absentCpT7", label: "Nghỉ có phép (T7)", totalKey: "absentCpT7Total", monthBeforeKey: "absentCpT7TotalMonthBefore", valueKey: "absentCpT7" },
        { key: "absentKpT7", label: "Nghỉ không phép (T7)", totalKey: "absentKpT7Total", monthBeforeKey: "absentKpT7TotalMonthBefore", valueKey: "absentKpT7" },
        { key: "leaveLater", label: "Đón muộn", totalKey: "leaveLaterTotal", monthBeforeKey: "leaveLaterTotalMonthBefore", valueKey: "leaveLater" },
        { key: "quantityDate", label: "Số ngày theo lịch hàng tháng", totalKey: "quantityDateTotal", monthBeforeKey: "quantityDateTotalMonthBefore", valueKey: "quantityDate" },
      ];
    },
  },
  methods: {
    open(row) {
      if (!row || !row.idx) {
        NotifyMessage.leftCornerNotificationWarning("Không tìm thấy thông tin phiếu thu.");
        return;
      }
      this.idx = row.idx;
      this.studentName = row.fullName || "";
      this.month = row.month || null;
      this.year = row.year || null;
      this.turn = row.turn || null;
      this.visible = true;
      this.fetchData();
    },

    async fetchData() {
      this.loading = true;
      try {
        const response = await ManagingStudentInvoiceService.getAdditionalInfo(this.idx);
        // Backend DTO could be directly in response.data or response.data.data
        const info = response?.data?.data ?? response?.data;
        this.hydrateDataForm(info);
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError("Không thể tải thông tin điểm danh bổ sung từ máy chủ.");
        this.hydrateDataForm(null);
      } finally {
        this.loading = false;
      }
    },

    valueOrZero(value) {
      if (value === null || value === undefined || value === "") return 0;
      return value;
    },

    normalizeNumber(value) {
      const num = Number(value);
      if (Number.isNaN(num) || num < 0) return 0;
      return Math.floor(num);
    },

    hydrateDataForm(info) {
      const source = info || {};
      const base = createDefaultDataForm();
      const next = { ...base, ...source };

      this.metricRows.forEach((item) => {
        next[item.valueKey] = this.normalizeNumber(next[item.valueKey]);
        next[item.totalKey] = this.normalizeNumber(next[item.totalKey]);
        next[item.monthBeforeKey] = this.normalizeNumber(next[item.monthBeforeKey]);
      });

      this.dataForm = next;
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate();
        }
      });
    },

    validateNonNegativeInteger(rule, value, callback) {
      const num = Number(value);
      if (Number.isNaN(num) || num < 0) {
        callback(new Error("Giá trị phải lớn hơn hoặc bằng 0"));
        return;
      }
      callback();
    },

    handleClose() {
      this.visible = false;
    },

    handleClosed() {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields();
      }
      this.dataForm = createDefaultDataForm();
      this.idx = "";
      this.studentName = "";
      this.month = null;
      this.year = null;
      this.turn = null;
      this.$emit("close");
    },

    handleSave() {
      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) return;

        this.saving = true;
        try {
          const payload = { ...this.dataForm };
          delete payload.preCalcStartDate;
          delete payload.preCalcEndDate;
          delete payload.postCalcStartDate;
          delete payload.postCalcEndDate;
          delete payload.startValidityPeriod;
          delete payload.endValidityPeriod;
          const response = await ManagingStudentInvoiceService.updateAdditionalInfo(this.idx, payload);
          const isSuccess = response?.data?.data === true || response?.data === true;
          if (isSuccess) {
            NotifyMessage.leftCornerNotificationSuccess("Cập nhật thông tin bổ sung thành công.");
            this.$emit("saved");
            this.handleClose();
          } else {
            throw new Error("Lưu thất bại.");
          }
        } catch (error) {
          console.error(error);
          NotifyMessage.leftCornerNotificationError(
            (error && error.response && error.response.data && error.response.data.message) ||
              "Lưu thông tin bổ sung thất bại."
          );
        } finally {
          this.saving = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog";

.aid-dialog {
  font-family: Inter, Arial, Helvetica, sans-serif;

  &__panel {
    border-radius: 14px;
  }

  &__subtitle {
    margin: 0 0 4px;
    font-size: 13px;
    color: #64748b;
  }

  &__head {
    display: grid;
    grid-template-columns: 2fr 1fr 1.1fr 1.2fr;
    gap: 8px;
    align-items: center;
    font-weight: 700;
    color: #1e293b;
    border-bottom: 1px solid #e2e8f0;
    padding: 8px 0;

    > div {
      text-align: center;
    }

    > div:first-child {
      text-align: left;
    }
  }

  &__row {
    display: grid;
    grid-template-columns: 2fr 1fr 1.1fr 1.2fr;
    gap: 8px;
    align-items: center;
    border-bottom: 1px solid #f1f5f9;
    padding: 8px 0;
  }

  &__cell {
    color: #475569;
    font-size: 13px;
    text-align: center;

    &--title {
      color: #1e293b;
      font-weight: 600;
      text-align: left;
    }

    &--edit {
      min-width: 120px;
      justify-self: center;
    }
  }

  &__form-item {
    margin-bottom: 0;
  }

  &__last-form-item {
    margin-bottom: 0;
  }
}

/deep/ .aid-dialog .el-input-number {
  width: 100%;
}

@media (max-width: 768px) {
  .aid-dialog {
    &__head,
    &__row {
      grid-template-columns: 1.8fr 0.9fr 0.9fr 1.1fr;
      gap: 6px;
      font-size: 12px;
    }
  }
}
</style>
